import type { MerchantPermissionId } from "@/modules/roles/domain/contracts/merchant-permissions";

/** ชื่อกลุ่มสิทธิ์สำหรับแสดงในฟอร์ม */
const GROUP_LABELS: Record<string, string> = {
  catalog: "ສິນຄ້າ / Catalog",
  inventory: "ສາງ / Inventory",
  pos: "ຂາຍ / POS",
  settlement: "ຊຳລະ / Settlement",
  shop_staff: "ພະນັກງານ",
  shop_roles: "ບົດບາດ",
  claims: "ເຄສສິນຄ້າ / Claims",
  promotions: "ໂປຣໂມຊັນ / Promotions",
  workshop: "ງານສ້ອມ / Workshop",
};

const ACTION_LABELS: Record<string, string> = {
  read: "ອ່ານ",
  create: "ສ້າງ",
  update: "ແກ້ໄຂ",
  delete: "ລົບ",
  adjust: "ປັບ",
  transfer: "ໂອນ",
  sell: "ຂາຍ",
  refund: "ຄືນເງິນ",
  void: "ຍົກເລີກ",
  request_payout: "ຂໍຊຳລະ",
  manage: "ຈັດການ",
};

function permissionToLabel(permId: string): string {
  const [group, action] = permId.split(":");
  const g = GROUP_LABELS[group!] ?? group;
  const a = ACTION_LABELS[action!] ?? action;
  return `${g}: ${a}`;
}

/** จัดกลุ่ม permission ids ตาม MerchantPermissions สำหรับใช้ในฟอร์มเลือกสิทธิ์ */
export type PermissionGroup = {
  groupLabel: string;
  items: { id: MerchantPermissionId; label: string }[];
};

export function getPermissionGroups(
  permissionIds: string[],
): PermissionGroup[] {
  const byGroup = new Map<
    string,
    { id: MerchantPermissionId; label: string }[]
  >();
  for (const id of permissionIds) {
    const [group] = id.split(":");
    const label = permissionToLabel(id);
    if (!byGroup.has(group!)) byGroup.set(group!, []);
    const list = byGroup.get(group!);
    if (list) list.push({ id: id as MerchantPermissionId, label });
  }
  return Array.from(byGroup.entries()).map(([group, items]) => ({
    groupLabel: GROUP_LABELS[group] ?? group,
    items: items.sort((a, b) => a.label.localeCompare(b.label)),
  }));
}

export function getPermissionLabel(permId: string): string {
  return permissionToLabel(permId);
}
